
function openMenu() {
    $(".menu-header").slideToggle("fast");

    if ($("header")[0].classList.contains("header-site")){
        $(".menu-header").css("top", $("header").height());
    } else {
        $(".menu-header").css("top", $(".hlogo").height() + 3);
    }
}

export default () => {
    $("button.hamburguer-icon").on("click", function () {
        openMenu();
    });
}
